import { Input, InputProps } from 'antd';
import React from 'react';
import './styles.scss';

const KeyToVal = {
  key1: 'default',
  key2: 'focused',
  key3: 'success',
  key4: 'warning',
  key5: 'error',
} as const;

type Keys = keyof typeof KeyToVal;
type Values = (typeof KeyToVal)[Keys];

export interface IOtoriInputProps extends InputProps {
  inputType?: Values;
}

export const TierHubInput: React.FC<IOtoriInputProps> = (props: IOtoriInputProps) => {
  const { className, inputType = 'default' } = props;

  return (
    <Input
      className={
        className
          ? `${className} ${className}--${inputType}`
          : `tier-hub-input tier-hub-input--${inputType}`
      }
      {...props}
    />
  );
};

export default TierHubInput;
